// polyfills
import "core-js/stable";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";
import { unregister } from "./registerServiceWorker";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(<App />, document.getElementById("root"));
unregister();

if (module.hot) {
  module.hot.accept();
}
